import { Outlet, useNavigate } from 'react-router-dom'
import { DASHBOARD_CONTENT_CONTAINER_ID, PAGE_LINKS } from '@/router/pageConst'
import { commonUtils } from '@/helpers/commonUtils'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'
import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import styles from './BaseDashboardLayout.module.less'
import { trackingService } from '@/services/trackingService'

type Props = {
  sidebar: React.ReactNode
}

function BaseDashboardLayout({ sidebar }: Props) {
  const navigate = useNavigate()

  /**
   * NOTE: 目前移动端不支持调转后台，这里因为首页会有 google 登陆，由后端调转
   * 后台，所以这里加一个兜底的逻辑，在后台重新定位到首页
   */
  const isMobile = useIsMobile()
  useEffect(() => {
    if (isMobile) {
      navigate(PAGE_LINKS.index, { replace: true })
      return
    }
    trackingService.trackDashboardPageView()
  }, [isMobile, navigate])

  return (
    <ErrorBoundary>
      <div className={styles.dashboardLayout}>
        <div className={styles.dashboardLayoutContent}>
          <img
            className={styles.bg3}
            src={commonUtils.getImagePath('dashboardLayout/bg-3.png')}
            alt=''
          />
          {sidebar}
          <div className={styles.dashboardLayoutContentPage} id={DASHBOARD_CONTENT_CONTAINER_ID}>
            <Outlet />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default observer(BaseDashboardLayout)
